module.exports = __webpack_public_path__ + "static/media/nft-14.2a8d76cb.jpg";